import { Action, createReducer, on } from '@ngrx/store';
import { EventSwitcherView } from '../../modules/main/enums/eventSwitcherView.enum';
import * as EventSwitcherActions from '../actions/eventSwitcher.actions';

export interface EventSwitcherState {
  eventSwitcherView: EventSwitcherView | undefined;
}

export const initialState: EventSwitcherState = {
  eventSwitcherView: undefined,
};

export const eventSwitcherViewReducer = createReducer<EventSwitcherState>(
  initialState,
  on(
    EventSwitcherActions.setActiveEventSwitcherViewAction,
    (
      state: EventSwitcherState,
      { payload: { eventSwitcherView } }: { payload: { eventSwitcherView: EventSwitcherView } }
    ) => {
      return {
        ...state,
        eventSwitcherView,
      };
    }
  )
);

export function EventSwitcherViewReducer(state: EventSwitcherState | undefined, action: Action): EventSwitcherState {
  return eventSwitcherViewReducer(state, action);
}

export const getEventSwitcherView = (state: EventSwitcherState) => state.eventSwitcherView;
